
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/software-quality-assurance-services",
      function () {
        return require("private-next-pages/software-quality-assurance-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/software-quality-assurance-services"])
      });
    }
  